import { Util } from '@libs/utilities/util';

import { IPodDesign } from '../contracts/pod-design.interface';
import { IPodListingDisplate } from '../contracts/pod-listing.interface';
import { EnumDisplateArtworkType, EnumPodImageColorType } from '../contracts/print-on-demand.constants';
import { IUploadPodDesignBackground, UPLOAD_CONFIG } from '../upload.config';


/**------------------------------------------------------
 * Export Displate data in the old XML-Format
 */
export class DisplateExportService {

	//** Configurations */
	readonly DESIGN_BACKGROUNDS: IUploadPodDesignBackground = UPLOAD_CONFIG.POD.DESIGN_BACKGROUNDS;


	//** Exporting the global data as xml */
	getXmlFormattedData(data: IPodDesign): IDisplateXmlData {

		//0 - get the displate listing data
		const displateData: IPodListingDisplate | null = data.listing?.displate;

		//1 - format the displate data into the old xml standard
		const formattedData: IDisplateXmlData = {
			title 			 : displateData?.text.title 			  || '',
			description 	 : displateData?.text.description 		  || '',
			keywords 	 	 : displateData?.text.keywords.join(', ') || '',
			collection  	 : displateData?.options.collection 	  || '',
			type			 : Util.String.firstCharUpper(displateData?.options.artworkType || EnumDisplateArtworkType.Illustration),
			scaling 		 : true,
			background_color : displateData?.options.background || this.getFallbackBackgroundColor(data),
			category 		 : displateData?.options.categories.map((elem: string) => Util.String.titleCase(elem)).join(', ').trim() || ''
		};

		return formattedData;
	}


	/**------------------------------------------------------
	 * Helper Functions
	 */
	private getFallbackBackgroundColor(data: IPodDesign) {
		return (data.image.colors.colorType === EnumPodImageColorType.Light)
			? this.DESIGN_BACKGROUNDS.EDIT.DISPLATE.BLACK
			: this.DESIGN_BACKGROUNDS.EDIT.DISPLATE.WHITE;
	}
}


//** Interfaces --------------------------------- */
export interface IDisplateXmlData {
	title 			 : string;
	description 	 : string;
	keywords		 : string;
	collection  	 : string;
	type			 : string;
	scaling 		 : boolean;
	background_color : string;
	category 		 : string;
}
